import React from 'react';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';
import { isEmpty } from '../../../../../../../core/util/empty';

class ExplanationPlanTypeHmo extends Base {
  static isVisible = ({ planType }: any) => !isEmpty(planType) && planType.toUpperCase() === 'HMO';

  icon = '/images/insurance_tutorial/03_ppo_hmo.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>
          <CopyContainer>
            <H2>You have an HMO</H2>
            <P>
              With your plan, you'll choose a Primary Care Physician. They'll take care of most of{' '}
              your needs. But&mdash;and this part is important&mdash;if you have to see a{' '}
              specialist, you'll need a referral.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default ExplanationPlanTypeHmo;
